import React from "react";

import styles from "./FullPageLoader.module.scss";

const FullPageLoader = () => {
  return (
    <div className={styles.loaderPage}>
      <div className={styles.loader}></div>
      <div className={styles.loaderText}>Please wait, we’re getting things ready...</div>
    </div>
  );
};

export default FullPageLoader;
